var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.05 1.4H13.6C14.815 1.4 15.8 2.38497 15.8 3.6V13.8C15.8 15.015 14.815 16 13.6 16H4.79998C3.58495 16 2.59998 15.015 2.59998 13.8V3.6C2.59998 2.38497 3.58495 1.4 4.79998 1.4H5.34995C5.66998 0.580529 6.46718 0 7.39998 0H11C11.9328 0 12.73 0.580529 13.05 1.4ZM5.28279 3.4H4.79998C4.68952 3.4 4.59998 3.48954 4.59998 3.6V13.8C4.59998 13.9105 4.68952 14 4.79998 14H13.6C13.7104 14 13.8 13.9105 13.8 13.8V3.6C13.8 3.48954 13.7104 3.4 13.6 3.4H13.1172C12.856 4.3234 12.007 5 11 5H7.39998C6.39295 5 5.54396 4.3234 5.28279 3.4ZM7.19998 2.2C7.19998 2.08954 7.28952 2 7.39998 2H11C11.1104 2 11.2 2.08954 11.2 2.2V2.8C11.2 2.91046 11.1104 3 11 3H7.39998C7.28952 3 7.19998 2.91046 7.19998 2.8V2.2Z",
    fill: "#9296AC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#D0D3E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71261 7.76017C5.81744 7.85003 5.82958 8.00786 5.73973 8.11269C5.20916 8.73061 4.67099 9.34854 4.07518 9.90463C3.91362 10.0554 3.68961 10.3 3.44991 10.3C3.27841 10.3 3.12696 10.1901 3.00306 10.0824C2.71115 9.82856 2.46637 9.50873 2.24519 9.19348C2.16602 9.08037 2.19344 8.92436 2.30655 8.84518C2.41965 8.76601 2.57552 8.79351 2.6547 8.90659L2.655 8.90702C2.85304 9.18841 3.07012 9.47811 3.33115 9.70509C3.37479 9.74304 3.41079 9.76959 3.4384 9.78618C3.54557 9.716 3.64073 9.62618 3.73402 9.5391C4.31634 8.9956 4.84096 8.39075 5.36004 7.78736C5.4499 7.68252 5.60778 7.67032 5.71261 7.76017Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffCertificate);
export default __webpack_public_path__ + "static/media/offCertificate.424315f9dc2daf91d1eafdffc56524e9.svg";
export { ForwardRef as ReactComponent };